import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { sendOtp} from "../api/core";
import "./login.css";
import Global from "../../global";
import "toastr/build/toastr.min.css";
import Loader from "../loader/loader";
import { UserStore } from "../store/store";
import  Cookies from "js-cookie";
const SendOtp = (props) => {


  let history = useHistory();
  const currentUser = UserStore.useState(s => s.user);
  const [loading, setLoading] = useState(false);
     /* eslint-disable no-unused-vars */
  const [otpVal,setOTPVAl] =useState((Cookies.get('sm_ott_val')==="true")) ;
     /* eslint-disable no-unused-vars */


  useEffect(() => {
     
    if(currentUser.PHONE_VERIFIED || !Global.OTP || otpVal)
    {
      let path = "/" + props.match.params.AppId + "/home";

    
      history.push(path);
    }

  }, [history,currentUser.PHONE_VERIFIED,props.match.params.AppId,otpVal]);

  const verify = async (event) => {
    setLoading(true);
    event.preventDefault();
    /* eslint-disable no-unused-vars */
    sendOtp(Global.OTPKey,currentUser.PHONE,props.match.params.AppId,history);
   
    /* eslint-disable no-unused-vars */
  };
  if (!loading && !currentUser.PHONE_VERIFIED) {
    return (
      <div>
        <section
          className="sign-in-page"
          style={{
            background: "url(/images/home/show-1.jpg) no-repeat scroll 0 0",
          }}
        >
          <div className="container">
            <div className="row justify-content-center align-items-center height-self-center">
              <div className="col-lg-5 col-md-12 align-self-center">
                <div className="sign-user_card ">
                  <div className="sign-in-page-data">
                    <div className="sign-in-from w-100 m-auto">
                      <h3 className="mb-3 text-center">Send OTP</h3>
                      <p className="mt-3">
                        An Otp will be sent to your registered number {currentUser.PHONE.replace(/.(?=.{4})/g, 'x')}  Please Click Send OTP Button 
                      </p>
                      <form className="mt-4" onSubmit={verify}>
                        <div className="form-group">
                        
                        </div>

                        <div className="sign-info">
                          <button
                            type="submit"
                            className="btn btn-hover"
                            style={{ float: "right" }}
                          >
                            Send Otp
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                  <div style={{ paddingTop: "40px" }}></div>

                
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  } else {
    return <Loader load={"Default"}></Loader>;
  }
};


export default SendOtp;
